/* The Crypto Closet: live coin prices, shopper-interest tracking, recently viewed, sticky add to cart */
(function () {
  'use strict';
  var CFG = window.ccCfg || {};
  var T = CFG.t || {};
  var COINS = {
    BTC: 'bitcoin', ETH: 'ethereum', SOL: 'solana', XRP: 'ripple', BNB: 'binancecoin', LINK: 'chainlink',
    DOGE: 'dogecoin', ADA: 'cardano', TRX: 'tron', SC: 'siacoin', LTC: 'litecoin', AVAX: 'avalanche-2',
    SHIB: 'shiba-inu', FIL: 'filecoin', SAND: 'the-sandbox', ZEC: 'zcash', XMR: 'monero', XLM: 'stellar', BCH: 'bitcoin-cash',
    NEAR: 'near', UNI: 'uniswap', DAI: 'dai', HBAR: 'hedera-hashgraph', CRO: 'crypto-com-chain', AAVE: 'aave', ICP: 'internet-computer',
    ETC: 'ethereum-classic', POL: 'polygon-ecosystem-token', ALGO: 'algorand'
  };
  var HANDLES = {
    'bitcoin-btc': 'BTC', 'ethereum': 'ETH', 'solana-sol': 'SOL', 'ripple-xrp': 'XRP', 'binance-coin-bnb': 'BNB',
    'chainlink-link': 'LINK', 'dogecoin-doge': 'DOGE', 'cardano-ada': 'ADA', 'tron-trx': 'TRX', 'siacoin-sc-1': 'SC',
    'litecoin-ltc': 'LTC', 'avalanche-avax': 'AVAX', 'shiba-inu-shib': 'SHIB', 'filecoin-fil': 'FIL', 'the-sandbox-sand': 'SAND',
    'zcash-zec': 'ZEC', 'monero-xmr': 'XMR', 'stellar-xlm': 'XLM', 'bitcoin-cash-bch': 'BCH', 'near-protocol-near': 'NEAR', 'uniswap-uni': 'UNI',
    'dai-dai': 'DAI', 'hedera-hbar': 'HBAR', 'cronos-cro': 'CRO', 'aave-aave': 'AAVE', 'internet-computer-icp': 'ICP',
    'ethereum-classic-etc': 'ETC', 'polygon-pol': 'POL', 'algorand-algo': 'ALGO'
  };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function coinOf(title) {
    if (!title || title.indexOf(' - ') < 0) return null;
    var t = title.split(' - ').pop().trim().toUpperCase();
    return COINS[t] ? t : null;
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  var cur = ((window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || 'EUR').toLowerCase();
  var lang = document.documentElement.lang || 'en';
  function fmtPrice(v, c) {
    var d = v >= 1000 ? 0 : v >= 1 ? 2 : v >= 0.01 ? 4 : 6;
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: c.toUpperCase(), minimumFractionDigits: d, maximumFractionDigits: d }).format(v); }
    catch (e) { return v.toFixed(d) + ' ' + c.toUpperCase(); }
  }
  function fmtChange(ch) {
    if (ch == null || isNaN(ch)) return '';
    return (ch >= 0 ? '▲ ' : '▼ ') + Math.abs(ch).toFixed(1) + '%';
  }
  function injectAuto() {
    var P = window.ccPage || {};
    var tick = null, anchor = null;
    if (P.t === 'collection' && HANDLES[P.c]) { tick = HANDLES[P.c]; anchor = document.querySelector('.collection-hero__title'); }
    if (P.t === 'product') { tick = coinOf(P.p); anchor = document.querySelector('.cc-pdp-eyebrow'); }
    if (!tick || !anchor || anchor.parentNode.querySelector('.cc-livepill')) return;
    var pill = el('span', 'cc-livepill');
    pill.setAttribute('data-cc-tick', tick);
    pill.innerHTML = '<i class="cc-livedot"></i><b>' + tick + '</b> <span data-f="price">…</span> <em data-f="change"></em> <small>' + (T.live || 'Live price') + '</small>';
    pill.hidden = true;
    anchor.insertAdjacentElement('afterend', pill);
  }
  function paint(data) {
    document.querySelectorAll('[data-cc-tick]').forEach(function (n) {
      var id = COINS[n.getAttribute('data-cc-tick')];
      var d = data[id];
      if (!d) return;
      var c = d[cur] != null ? cur : 'usd';
      var price = d[c], ch = d[c + '_24h_change'];
      var pe = n.matches('[data-f="price"]') ? n : n.querySelector('[data-f="price"]');
      var ce = n.matches('[data-f="change"]') ? n : n.querySelector('[data-f="change"]');
      if (pe && price != null) pe.textContent = fmtPrice(price, c);
      if (ce) { ce.textContent = fmtChange(ch); ce.classList.toggle('is-up', ch >= 0); ce.classList.toggle('is-down', ch < 0); }
      n.hidden = false;
      n.classList.add('is-live');
    });
    var stamp = document.querySelectorAll('[data-cc-live-time]');
    var now = new Date();
    stamp.forEach(function (s) { s.textContent = (T.updated || 'Updated') + ' ' + now.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' }); });
  }
  function loadPrices() {
    var ticks = {};
    document.querySelectorAll('[data-cc-tick]').forEach(function (n) { var t = n.getAttribute('data-cc-tick'); if (COINS[t]) ticks[COINS[t]] = 1; });
    var ids = Object.keys(ticks).sort();
    if (!ids.length) return;
    var key = 'ccPx:' + cur + ':' + ids.join(',');
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < 60000) { paint(cached.d); return; }
    } catch (e) {}
    var cs = cur === 'usd' ? 'usd' : cur + ',usd';
    fetch('https://api.coingecko.com/api/v3/simple/price?ids=' + ids.join(',') + '&vs_currencies=' + cs + '&include_24hr_change=true')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} paint(d); })
      .catch(function () { });
  }

  function bump(tick, w) {
    if (!tick) return;
    var a = store.get('ccAff', {});
    a[tick] = (a[tick] || 0) + w;
    store.set('ccAff', a);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cc-coin]');
    if (a) bump(a.getAttribute('data-cc-coin'), 1);
    var chip = e.target.closest && e.target.closest('[data-cc-tab]');
    if (chip) bump(chip.getAttribute('data-cc-tab').toUpperCase(), 1);
  }, true);

  function money(cents) {
    var c = ((window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR');
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: c }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + c; }
  }
  function recent() {
    var P = window.ccPage || {};
    var list = store.get('ccRecent', []);
    if (P.t === 'product' && P.h) {
      bump(coinOf(P.p), 3);
      list = [P.h].concat(list.filter(function (h) { return h !== P.h; })).slice(0, 12);
      store.set('ccRecent', list);
    }
    var box = document.querySelector('[data-cc-recent]');
    if (!box) return;
    var show = list.filter(function (h) { return h !== P.h && h !== 'custom-coin-add-on'; }).slice(0, 8);
    if (!show.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var grid = box.querySelector('[data-cc-recent-grid]');
    Promise.all(show.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) return;
      items.forEach(function (p) {
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        var li = el('li');
        var tick = coinOf(p.title);
        li.innerHTML = '<a class="cc-cb__card" href="' + p.url + '"' + (tick ? ' data-cc-coin="' + tick + '"' : '') + '>' +
          '<span class="cc-cb__img">' + (img ? '<img loading="lazy" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="">' : '') + '</span>' +
          '<span class="cc-cb__name"></span><span class="cc-cb__price">' + ((p.price_varies ? (T.from || 'From') + ' ' : '') + money(p.price_min)) + '</span></a>';
        li.querySelector('.cc-cb__name').textContent = p.title.split(' - ')[0];
        grid.appendChild(li);
      });
      box.hidden = false;
    });
  }
  function sticky() {
    var P = window.ccPage || {};
    if (P.t !== 'product' || P.h === 'custom-coin-add-on') return;
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;
    var bar = el('div', 'cc-sticky');
    var img = document.querySelector('.product__media img');
    var price = document.querySelector('.price__container .price-item--regular, .price__container .price-item--sale');
    bar.innerHTML = '<div class="cc-sticky__in page-width">' +
      (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
      '<div class="cc-sticky__txt"><b></b><span></span></div>' +
      '<button type="button" class="button button--primary cc-sticky__btn"></button></div>';
    bar.querySelector('b').textContent = (P.p || '').split(' - ')[0];
    bar.querySelector('.cc-sticky__txt span').textContent = price ? price.textContent.trim() : '';
    bar.querySelector('button').textContent = T.sticky || 'Add to cart';
    bar.querySelector('button').addEventListener('click', function () {
      if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      btn.click();
    });
    document.body.appendChild(bar);
    function upd() { var r = btn.getBoundingClientRect(); bar.classList.toggle('is-on', r.bottom < 0); }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function init() { injectAuto(); loadPrices(); recent(); sticky(); setInterval(function () { if (!document.hidden) loadPrices(); }, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.ccLive = { refresh: loadPrices, coinOf: coinOf, aff: function () { return store.get('ccAff', {}); } };
})();